import axios from "axios";

let getContext = () => ({ baseUrl: "", token: "" });

export function bindHttpContext(fn: () => { baseUrl: string; token: string }) {
  getContext = fn;
}

export const http = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const { baseUrl, token } = getContext();
  if (!config.baseURL) {
    config.baseURL = baseUrl;
  }
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    if (config.headers && typeof (config.headers as { set?: (name: string, value?: string) => void }).set === "function") {
      (config.headers as { set: (name: string, value?: string) => void }).set("Content-Type", undefined);
    } else if (config.headers) {
      delete (config.headers as Record<string, unknown>)["Content-Type"];
    }
  }
  return config;
});
